const paths = {
  root: '/',

  assistant: '/assistant',
  party: '/party',
  settings: '/settings',
  conceptReply: '/concept-reply',

  policies: {
    overview: '/policies',
    detail: '/policies/:id',
  },
  policyPackages: {
    detail: '/policy-packages/:id',
  },
  riskObjects: {
    overview: '/risk-objects',
    detail: '/risk-objects/:id',
  },
  claims: {
    overview: '/claims',
    detail: '/claims/:id',
  },
  invoices: {
    overview: '/invoices',
    detail: '/invoices/:id',
  },
  documents: {
    overview: '/documents',
  },
  notes: {
    overview: '/notes',
    detail: '/notes/:id',
    create: '/notes/new',
  },
  login: {
    index: '/login',
    dialog: '/login/dialog',
    callback: '/login/callback',
  },

  onesurance: {
    recommendations: '/onesurance/recommendations',
  },
};

export default paths;
